import React from 'react';
import I18n from 'i18n-js';
import { RCCallout, RCIcon } from '@reverbdotcom/cadence/components';
import { ChevronRightIcon } from '@reverbdotcom/cadence/icons/react';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { NotificationsCenterQuery } from '@reverbdotcom/commons/src/gql/graphql';
import { clickedNotificationEvent } from './notification_event_props';

type NotificationAction = NotificationsCenterQuery['notificationActions']['actions'][number];

interface IProps {
  actions: NotificationAction[];
  summary: string;
  onOpenRollup: () => void;
}

export default function ActionsSection({ actions, summary, onOpenRollup }: IProps) {
  if (actions.length === 0) return null;

  return (
    <div className="notifications-center__actions">
      {actions.length === 1
        ? <ActionBanner action={actions[0]} />
        : <ActionsRollupBanner summary={summary} onClick={onOpenRollup} />
      }
    </div>
  );
}

function NagBox({ children }: { children: React.ReactNode }) {
  return (
    <RCCallout themeType="utility" variant="loud-ultralight" border="leading-accent" compact>
      <span className="notifications-center__nag__row">
        <span className="notifications-center__nag__copy">{children}</span>
        <span className="notifications-center__nag__chevron">
          <RCIcon icon={<ChevronRightIcon />} size={4} />
        </span>
      </span>
    </RCCallout>
  );
}

export function ActionBanner({ action }: { action: NotificationAction }) {
  return (
    <CoreLink
      to={action.href}
      className="notifications-center__nag"
      clickEvent={clickedNotificationEvent(action.eventTracking)}
    >
      <NagBox>
        {I18n.t('discovery.notificationsCenter.actions.bannerCopy', {
          title: action.title,
          description: action.description,
        })}
      </NagBox>
    </CoreLink>
  );
}

export function ActionsRollupBanner({ summary, onClick }: { summary: string; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="notifications-center__nag"
    >
      <NagBox>{summary}</NagBox>
    </button>
  );
}
